import { AssetSummaryRow } from 'components/Asset/AssetSummaryRow';
import { useSelector } from 'hooks/useSelector';
import React from 'react';
import { selectAsset } from 'store/assets/selectors';
import { selectAssetHasChanges } from 'store/changes/selectors';

interface Props {
  assetId: string;
}

export const AssetExplorerSummaryRow: React.FC<Props> = ({ assetId }) => {
  const asset = useSelector((state) => selectAsset(state, assetId));
  const hasChanges = useSelector((state) =>
    selectAssetHasChanges(state, assetId),
  );

  return (
    <AssetSummaryRow
      hasChanges={hasChanges}
      details={{
        name: asset.details.name,
        avatar: asset.details.avatar || '',
        reference: asset.reference,
        customReference: asset.details.custom_reference || '',
        parentName: asset.details.parentName || '',
        address1: asset.details.address1 || '',
        address2: asset.details.address2 || '',
        city: asset.details.city || '',
        county: asset.details.county || '',
        postcode: asset.details.postcode || '',
      }}
    />
  );
};
